export default {
  pt: {
    pageTitle: "Foto da bicicleta",
    titleReview: "Revisar foto",
    titleTake: "Agora é a vez da bicicleta",
    subtitleReview: "A foto está nítida e iluminada?<br />Não pode ter reflexo.",
    subtitleTake: "Tire uma foto nítida da bicicleta inteira.",
    continueButton: "Continuar",
    looksGoodButton: "Ficou legal!",
    takeAnotherButton: "Tirar outra",
    rule1Text: "Procure um local iluminado",
    rule2Text: "Crie um bom contraste com uma parede clara",
    rule3Text: "Enquadre toda a bicicleta",
    handoffDescription:
      "Para fotografar a bike, escaneie o QR code com a câmera do seu celular e continue por lá.",
  },

  en: {
    pageTitle: "Bicycle photo",
    titleReview: "Review photo",
    titleTake: "Now it's the bicycle's turn",
    subtitleReview: "Is the photo clear and well-lit?<br />No reflection allowed.",
    subtitleTake: "Take a clear photo of the entire bicycle.",
    continueButton: "Continue",
    looksGoodButton: "Looks good!",
    takeAnotherButton: "Take another",
    rule1Text: "Look for a well-lit location",
    rule2Text: "Create good contrast with a light wall",
    rule3Text: "Frame the entire bicycle",
    handoffDescription:
      "To photograph the bike, scan the QR code with your phone's camera and continue from there.",
  },
};
